module.exports = __webpack_public_path__ + "img/po.09137ef2.png";